import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Calendar, ArrowRight } from 'lucide-react';
export function NewsSection() {
  return <section className="py-16 bg-white" data-id="element-304">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-305">
        <div className="flex justify-between items-end mb-10" data-id="element-306">
          <h2 className="text-3xl font-bold text-uganda-black" data-id="element-307">
            Latest News & Updates
          </h2>
          <Link to="/media" className="hidden md:flex items-center text-uganda-green font-semibold hover:text-green-800 transition-colors" data-id="element-308">
            Media Center <ArrowRight className="w-5 h-5 ml-2" data-id="element-309" />
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8" data-id="element-310">
          {/* Featured News (Large) */}
          <Link to="/media" className="lg:col-span-6 group cursor-pointer block" data-id="element-311">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-312">
              <div className="relative h-64 md:h-80 w-full rounded-xl overflow-hidden mb-4" data-id="element-313">
                <img src="https://cdn.magicpatterns.com/uploads/xa6MfyJGpwadNmbRhCKigq/fdhjkl_(5).jpg" alt="Ugandan farmers working in green agricultural fields" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-314" />
                <div className="absolute top-4 left-4 bg-uganda-red text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-315">
                  Leadership
                </div>
              </div>
              <div className="flex items-center text-sm text-gray-500 mb-2" data-id="element-316">
                <Calendar className="w-4 h-4 mr-2" data-id="element-317" /> June 22, 2023
              </div>
              <h3 className="text-2xl font-bold text-uganda-black mb-3 group-hover:text-uganda-green transition-colors" data-id="element-318">
                Hon. Tumwebaze Promises a Hands-on Approach in the Agriculture
                Sector
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-319">
                Hon. Frank Tumwebaze, the new Minister of Agriculture, Animal
                Industry and Fisheries (MAAIF), has promised to apply a
                proactive approach through directly engaging farmers on ministry
                policies. He said this after taking office at the ministry
                headquarters in Entebbe.
              </p>
              <span className="text-uganda-green font-semibold text-sm flex items-center" data-id="element-320">
                Read Full Story <ArrowRight className="w-4 h-4 ml-1" data-id="element-321" />
              </span>
            </motion.div>
          </Link>

          {/* Smaller Cards & List */}
          <div className="lg:col-span-6 flex flex-col gap-8" data-id="element-322">
            {/* Two smaller cards row */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-323">
              <Link to="/media?tab=News" className="group cursor-pointer block" data-id="element-324">
                <motion.div initial={{
                opacity: 0,
                y: 20
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: 0.1
              }} data-id="element-325">
                  <div className="h-40 w-full rounded-lg overflow-hidden mb-3" data-id="element-326">
                    <img src="https://cdn.magicpatterns.com/uploads/74aFqzAG6hnsDYxqCbrTMd/fdhjkl_(6).jpg" alt="Coffee beans drying in the sun in Uganda" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-327" />
                  </div>
                  <div className="flex items-center text-xs text-gray-500 mb-2" data-id="element-328">
                    <Calendar className="w-3 h-3 mr-1" data-id="element-329" /> Recent
                  </div>
                  <h4 className="font-bold text-uganda-black group-hover:text-uganda-green transition-colors line-clamp-2" data-id="element-330">
                    Ministry Prioritizes Strategic Communication and Modern
                    Online Platforms
                  </h4>
                </motion.div>
              </Link>

              <Link to="/media?tab=News" className="group cursor-pointer block" data-id="element-331">
                <motion.div initial={{
                opacity: 0,
                y: 20
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: 0.2
              }} data-id="element-332">
                  <div className="h-40 w-full rounded-lg overflow-hidden mb-3" data-id="element-333">
                    <img src="https://images.unsplash.com/photo-1523741543316-beb7fc7023d8?w=600&h=400&fit=crop" alt="Lush green banana plantation in rural Uganda" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-334" />
                  </div>
                  <div className="flex items-center text-xs text-gray-500 mb-2" data-id="element-335">
                    <Calendar className="w-3 h-3 mr-1" data-id="element-336" /> Recent
                  </div>
                  <h4 className="font-bold text-uganda-black group-hover:text-uganda-green transition-colors line-clamp-2" data-id="element-337">
                    Launch of the National Agricultural Sector Portal for the
                    Republic of Uganda
                  </h4>
                </motion.div>
              </Link>
            </div>

            {/* List of Headlines */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="bg-gray-50 rounded-xl p-6 border border-gray-100 flex-grow" data-id="element-338">
              <h4 className="font-bold text-lg mb-4 border-b border-gray-200 pb-2" data-id="element-339">
                Ministry Activities
              </h4>
              <ul className="space-y-4" data-id="element-340">
                <li data-id="element-341">
                  <Link to="/about/extension-services" className="group cursor-pointer block" data-id="element-342">
                    <div className="text-xs text-uganda-yellow font-bold mb-1" data-id="element-343">
                      Engagement
                    </div>
                    <h5 className="font-medium text-sm text-uganda-black group-hover:text-uganda-green transition-colors" data-id="element-344">
                      Ongoing stakeholder engagements across regions to discuss
                      agricultural extension services.
                    </h5>
                  </Link>
                </li>
                <li data-id="element-345">
                  <Link to="/media" className="group cursor-pointer block" data-id="element-346">
                    <div className="text-xs text-uganda-green font-bold mb-1" data-id="element-347">
                      Publication
                    </div>
                    <h5 className="font-medium text-sm text-uganda-black group-hover:text-uganda-green transition-colors" data-id="element-348">
                      New media features showcasing work done within the
                      guidance of the Vision.
                    </h5>
                  </Link>
                </li>
                <li data-id="element-349">
                  <Link to="/weather-advisory" className="group cursor-pointer block" data-id="element-350">
                    <div className="text-xs text-blue-600 font-bold mb-1" data-id="element-351">
                      Advisory
                    </div>
                    <h5 className="font-medium text-sm text-uganda-black group-hover:text-uganda-green transition-colors" data-id="element-352">
                      Latest weather advisories and farming guidelines published
                      in the Library.
                    </h5>
                  </Link>
                </li>
              </ul>
            </motion.div>
          </div>
        </div>

        <div className="mt-8 text-center md:hidden" data-id="element-353">
          <Link to="/media" className="inline-flex items-center justify-center gap-2 bg-white border border-gray-200 text-uganda-black px-6 py-3 rounded-md font-semibold w-full" data-id="element-354">
            View Media Center <ArrowRight className="w-4 h-4" data-id="element-355" />
          </Link>
        </div>
      </div>
    </section>;
}